module.exports = __webpack_public_path__ + "img/exit.c2299a01.svg";